import { CFG } from '../config';
import { sumMacros } from '../utils';
import type { DayData } from '../types';

interface Props {
  days: DayData[];
}

export function MacrosPanel({ days }: Props) {
  const { protein, fat, carbs, daysWithData } = sumMacros(days);
  const avg = daysWithData || 1;

  const macros = [
    { name: 'Белки', val: protein / avg, target: CFG.protein, color: 'var(--green)' },
    { name: 'Жиры', val: fat / avg, target: CFG.fat, color: 'var(--yellow)' },
    { name: 'Углеводы', val: carbs / avg, target: CFG.carbs, color: 'var(--magenta)' },
  ];

  return (
    <div class="macros-panel">
      <div class="mp-title">MACROS // AVG DAY</div>
      {macros.map((m) => {
        const pct = Math.min(m.val / m.target * 100, 100);
        const cls = m.val >= m.target * 0.85 ? 'vm-good' : m.val >= m.target * 0.6 ? 'vm-warn' : 'vm-bad';
        const textColor = cls === 'vm-good' ? 'var(--green)' : cls === 'vm-warn' ? 'var(--yellow)' : 'var(--magenta)';
        return (
          <div key={m.name} class="mp-row">
            <div class="mp-name">{m.name}</div>
            <div class="mp-track">
              <div class="mp-fill" style={{ width: `${pct}%`, background: m.color }} />
            </div>
            <div class="mp-val" style={{ color: textColor }}>
              {Math.round(m.val)}/{m.target}g
            </div>
          </div>
        );
      })}
    </div>
  );
}
